import React, { useState } from 'react';
import { IconButton, Tooltip, TextField } from '@mui/material';
import { Done, Clear } from '@mui/icons-material';

/**
 * Clickable text field that supports inline editing with save & cancel
 */
const InlineTextEdit = ({
  value,
  onValueChange,
  disabled,
  label,
  type,
  placeholder,
  inputProps = {},
  fullWidth = true,
}) => {
  const [isEditing, setEditing] = useState(false);
  const [newVal, setNewVal] = useState(value || '');
  const reset = () => {
    setEditing(false);
    setNewVal(value);
  };
  return (
    <>
      <TextField
        fullWidth={fullWidth}
        disabled={disabled}
        value={isEditing ? newVal : value || ''}
        onClick={() => {
          if (!isEditing) setNewVal(value);
          setEditing(true);
        }}
        onChange={(e) => setNewVal(e.target.value)}
        label={label}
        placeholder={placeholder}
        type={type}
        inputProps={inputProps}
      />
      {isEditing && (
        <>
          <Tooltip title="Cancel">
            <IconButton aria-label="cancel" onClick={reset} size="large">
              <Clear className="icon" />
            </IconButton>
          </Tooltip>
          <Tooltip title={value === newVal ? 'No changes have been made' : 'Edit'}>
            <span>
              <IconButton
                disabled={value === newVal}
                aria-label="edit-confirm"
                onClick={() => onValueChange(newVal).then(reset)}
                size="large"
              >
                <Done className="icon" color={value === newVal ? 'error' : 'success'} />
              </IconButton>
            </span>
          </Tooltip>
        </>
      )}
    </>
  );
};

export default InlineTextEdit;
